export let Constants = {
    permissionNames: {
        canAccessWebAdmin: 'Can Access Web Admin',
    },

    railsEnvironments: {
        development: 'development',
        e2e_test: 'e2e_test',
        production: 'production'
    },

    externalPlatformNames: {
        stripe: 'Stripe',
        qbo: 'QBO'
    },

    fpServiceTypeNames: {
        internalService: 'Internal Service',
        internalExpense: 'Internal Expense',
        externalExpense: 'External Expense'
    },

    invoiceStatusNames: {
        notTracked: 'Not Tracked',
        billed: 'Billed',
        paid: 'Paid',
    },

    externalStripeInvoiceStatuses: {
        draft: 'draft',
        open: 'open',
        void: 'void'
    },

    invoiceTypes: {
        fpOnly: {
            name: "FP-only",
            className: "fp-only",
            iconSrc: "/static/images/invoice-fp-textcolor.svg"
        },
        oneOff: {
            name: "One-off",
            className: "one-off",
            iconSrc: "/static/images/invoice-one-off-textcolor.svg"
        },
        subscription: {
            name: "Subscription",
            className: "subscription",
            iconSrc: "/static/images/invoice-subscription-textcolor.svg"
        }
    },

    pagePathSegments: {
        invoices: 'invoices',
        subscriptions: 'subscriptions',
        subscriptionInvoices: 'subscription-invoices',
        fpQboIntegration: 'fp-qbo-integration',
        invoicePaymentSettings: 'invoice-payment-settings',
        users: 'users',
    },

    qboInvoiceLineTypes: {
        fpService: 'FP Service',
        custom: 'Custom'
    },

    stripeFpInvoiceLinePresentation: {
        totalsByServiceGroup: "Totals by FP service group",
        allLines: "All FP invoice lines"
    },

    qboFpInvoiceLinePresentation: {
        totalsByServiceType: "Totals by FP service type",
        allLines: "All FP invoice lines"
    },

    subscriptionBillingPeriodOptionsHash: {
        monthly: {
            value: 'month',
            label: 'Monthly'
        },
        yearly: {
            value: 'year',
            label: 'Yearly'
        },
    },

    placeholderPassword: '********',
    minPasswordLength: 8,
    defaultPageNumber: 1,
    defaultPageCount: 1,
    searchDelayMs: 1000,
    debounceTimeoutMs: 400,
    maxInvoiceDescriptionLength: 500,
    maxSubscriptionDescriptionLength: 500,
    oneOffInvoiceCreditCardTotalThreshold: 3000,
    stripePaymentMethodTypeKeys: {
        card: 'card',
        link: 'link'
    },
    stripeFetchedPaymentMethodTypes: {
        card: 'Credit Card',
        link: 'Link',
        ach_debit: 'ACH Direct Debit',
        us_bank_account: 'ACH Direct Debit',
        customer_balance: 'Bank Transfer'
    }
};
